import axios from "axios";


const backendUrl = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${backendUrl.replace(/\/$/, "")}/api`,
  withCredentials: true,
  timeout: 15000,
});

let refreshRequest = null;

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const requestUrl = originalRequest?.url || "";
    const skipsRefresh = ["/auth/login", "/auth/refresh", "/auth/forgot-password"]
      .some((path) => requestUrl.includes(path));

    if (
      error.response?.status !== 401
      || originalRequest?._retry
      || skipsRefresh
    ) {
      return Promise.reject(error);
    }

    originalRequest._retry = true;
    refreshRequest ??= api.post("/auth/refresh").finally(() => {
      refreshRequest = null;
    });

    try {
      await refreshRequest;
      return api(originalRequest);
    } catch (refreshError) {
      window.dispatchEvent(new Event("aneka-auth-expired"));
      return Promise.reject(refreshError);
    }
  },
);

export const formatApiError = (error) => {
  const detail = error.response?.data?.detail;

  if (typeof detail === "string") {
    return detail;
  }

  if (Array.isArray(detail)) {
    return detail
      .map((item) => item?.msg || "Input tidak valid.")
      .join(" ");
  }

  return "Terjadi kendala. Silakan coba lagi.";
};